import {
  PAGELIST_FETCHITEMS_LOAD,
  PAGELIST_FETCHITEMS_SUCCEED,
  PAGELIST_FETCHITEMS_FAIL,
  PAGELIST_CHANGETABLE_CHANGE,
  PAGELIST_SEARCHTABLE_EDIT,
  PAGELIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case PAGELIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case PAGELIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case PAGELIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case PAGELIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case PAGELIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case PAGELIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}
